import './bootstrap';

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/cookiebar/index';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
import 'masonry-layout/dist/masonry.pkgd'
import './wwdev/lazysizes/index.js';
import './wwdev/webshop/index.js';
// import '@wwdev/myaccount/index.js';
// import '@wwdev/register';
import '@wwdev/search';
import '@wwdev/functions/setEqualHeightsPerRow';
import './externals/hamburgers.js';
import './externals/flickity/index.js';
import './externals/animation.js';
import './externals/slider/index.js';

import './base/SmoothScroll.js';

// Vendor
import './vendor/Shared/Header.js';
import './vendor/Shared/PicturePopup.js'
import Header from './externals/mobile-header.js';
import ResizingSelect from "./base/ResizingSelect";
import './vendor/Dealer/Overview.js';
import './vendor/Contentable/overview.js';

// Base
import './base/ModalPopup.js'

// Externals
import '@hebeta/samplerequest';
import '@hebeta/quotation';
import '@hebeta/favorite';

// Sections
import './sections/TitleImageTabs.js';
import './sections/ConfiguratorSlider.js';
import './sections/TextAccordion.js';

new Header();

new ResizingSelect();

